import React from 'react';
import Tooltip from '@material-ui/core/Tooltip';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';

const LightTooltip = withStyles(theme => ({
  tooltip: {
    backgroundColor: props => (props.dark ? theme.palette.primary.adgmBlack : theme.palette.common.white),
    color: props => (props.dark ? '#FFFFFF' : '#342D3D'),
    boxShadow: 'none',
    fontSize: '12px',
    borderRadius: '10px',
    fontWeight: 400,
    padding: '12px',
  },
}))(Tooltip);

function LightTooltipComponent({ children, title, dark, ...otherProps }) {
  return (
    <>
      <LightTooltip dark={dark} title={title} placement='top-start' {...otherProps}>
        {children}
      </LightTooltip>
    </>
  );
}

LightTooltipComponent.propTypes = {
  children: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
  dark: PropTypes.bool,
};

LightTooltipComponent.defaultProps = {
  dark: false,
};

export default LightTooltipComponent;
